import type { V1Step } from '@/generated/hooks/grimoire/models';
import { formatStepReference } from '@/shared/utils/step-reference';

/** Builds the `<step_reference>` tag embedded in an outgoing chat message
 *  for a step's "add to chat" affordance — its number, title, and entry
 *  function name, enough for the agent to identify which step the user
 *  means without duplicating the step's full content into every message.
 *  `runId` is passed when a live run preview is focused, so the reference
 *  ties to that run's actual execution rather than just the step's static
 *  definition. */
export function formatStepContext(step: V1Step, runId?: string): string {
  return formatStepReference({
    number: step.number ?? 0,
    title: step.title ?? '',
    fn: step.entry_function?.name,
    ...(runId ? { runId } : {}),
  });
}
